import * as braze from '@braze/web-sdk';
import { Braze } from '@foxdcg/cpe-commerce-web';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getContentCardByZone, getCustomEvent, getContentCardCampaignType } from 'Utils/Braze';
import { BANNER, CAPTIONED_IMAGE, MY_ACCOUNT_TOP, MY_ACCOUNT_2ND } from 'Utils/Constants';
import { logError } from 'Utils/Logger';
import './BrazeContentCard.css';
import { setLocation } from 'Utils/Path';

const BrazeContentCard = ({ zone, setCancelPromoRes = () => {}, withCloseButton }) => {
  const contentCards = useSelector((s) => s.contentCards.allContentCards);
  const myAccountPromo = [MY_ACCOUNT_TOP, MY_ACCOUNT_2ND].includes(zone);
  const brazeContentCard = getContentCardByZone(contentCards, zone);
  const campaignType = getContentCardCampaignType(brazeContentCard);

  const [contentCard, setContentCard] = useState(brazeContentCard);

  useEffect(() => {
    const brazeContentCard = getContentCardByZone(contentCards, zone);
    setContentCard(brazeContentCard);
  }, [contentCards, zone]);

  useEffect(() => {
    contentCard && braze.logContentCardImpressions([contentCard]);
  }, [contentCard]);

  const onContentCardClick = async () => {
    try {
      await Braze.bannerClickAction(contentCard);
      setCancelPromoRes('success');
      const customEvent = getCustomEvent(contentCard?.extras?.zone);
      braze.logCustomEvent(customEvent);
      braze.logContentCardClick(contentCard);
      contentCard?.url && setLocation(contentCard.url);
    } catch (error) {
      setCancelPromoRes('error');
      logError(error, 'Braze Content Card Click Error');
    }
  };

  // Braze Banner Display with One Click Action
  if (contentCard && (campaignType === BANNER || !campaignType)) {
    return (
      <div
        className={withCloseButton ? 'bannerImageWithCloseButton' : 'bannerImage'}
        onClick={!withCloseButton ? onContentCardClick : undefined}
      >
        <img className="brazeContent" width="675" height="200" src={contentCard?.imageUrl}></img>
        {withCloseButton && (
          <button
            className="bannerCloseButton"
            onClick={() => {
              setCancelPromoRes('');
            }}
          >
            <img src="/account/static/images/cross-mark-white.svg" width="10" height="10" alt="Close" />
          </button>
        )}
      </div>
    );
  }

  // Braze MyAccount Captioned Image Display with Payment Page redirect
  // TODO: Styling
  if (contentCard && myAccountPromo && campaignType === CAPTIONED_IMAGE) {
    return (
      <div className="bannerImage" onClick={onContentCardClick}>
        <img className="brazeContent" src={contentCard?.imageUrl}></img>
      </div>
    );
  }

  // Braze Captioned Image Display with One Click Action
  if (contentCard && campaignType === CAPTIONED_IMAGE) {
    return (
      <div className="captionedImageContainer">
        <img className="captionedImage" src={contentCard?.imageUrl} width="389" height="291"></img>
        <div className="captionedImageText">
          <div className="titleText">{contentCard.title}</div>
          <div className="descriptionText">{contentCard.description}</div>
          <button className="linkTextButton" onClick={onContentCardClick}>
            {contentCard.linkText}
          </button>
        </div>
      </div>
    );
  } else return null;
};

export default BrazeContentCard;
